import React from "react";
import "./AuthLayout.css"; // Import the CSS file
import Logo from "../../assets/Images/witmeg-logo.svg";

const AuthLayout = ({ children, leftWidth = "50%" }) => {
  return (
    <div className="auth-container" style={{ "--left-width": leftWidth }}>
      {/* Left Side - Form Section */}
      <div className="auth-left">
        <div className="auth-content">{children}</div>
      </div>

      {/* Right Side - Image Section */}
      <div className="auth-right">
        <div className="auth-image">
          <div className="witmeg-logo">
            <img src={Logo} alt="witmeg-logo" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
